export default {
  // Navigation
  nav_concept: "Concept",
  nav_features: "Features",
  nav_details: "Details",
  nav_content: "Class Content",
  nav_tuition: "Tuition",
  nav_instructor: "Instructor",
  nav_voices: "Testimonials",
  nav_faq: "FAQ",
  nav_register: "Register",
  nav_about: "About J-Motion",
  nav_contact: "Contact",
  
  // Hero Section
  hero_title: "J-Motion Academy — Learn in Motion. Live the language.",
  hero_subtitle: "A movement-based language class where children learn naturally through play, action, and communication.",
  hero_cta: "Free Trial Registration",
  
  // Concept
  concept_title: "Concept",
  concept_text1: "Children learn language best when they move, play, and interact.",
  concept_text2: "J-Motion Academy is not a sit-down, textbook-style class.",
  concept_text3: "It's an Active Language Class where learning happens through real movement, real joy, and real communication.",
  
  // Why J-Motion Academy
  why_jmotion_title: "Why J-Motion Academy?",
  founder_title: "About the Founder, Haru (Mari Haruno)",
  founder_text1: "Haru (Mari Haruno) has supported and taught children and adults with developmental differences for over 20 years.",
  founder_text2: "Through this experience, she realized that classic learning—lining up desks and chairs, using textbooks and pencils—is not the only way to learn.",
  method_title: "The J-Motion Method",
  method_text1: "Based on neuroscience, J-Motion offers experiential lessons that engage all five senses. Learners acquire language not only with their mind but with their entire body. Lessons are designed to be fun and natural, making language \"come alive\" in the body and creating memories that last a lifetime.",
  method_text2: "This method works for both Japanese and English and is especially beneficial for learners with strong developmental traits, providing a comfortable and enjoyable way to learn naturally.",
  
  // J-Motion Academy Programs
  academy_programs_title: "About J-Motion Academy",
  academy_intro: "J-Motion Academy consists of four divisions tailored to different ages and goals:",
  academy_kids: "J-Motion Kids: For ages 3-12",
  academy_youth: "J-Motion Youth: For ages 13-18",
  academy_japanese: "J-Motion Japanese: For adults",
  academy_english: "J-Motion English: For children and adults who want to learn English in Japanese",
  
  // Features
  features_title: "Features",
  
  // Lesson Highlights
  lesson_highlights_title: "Lesson Highlights",
  highlight1_title: "Engage All Five Senses",
  highlight1_desc: "Speaking, listening, seeing, touching",
  highlight2_title: "Active Learning",
  highlight2_desc: "Learners move and participate, not just observe",
  highlight3_title: "Acquire with the Body",
  highlight3_desc: "Acquire language with the body, not just the mind",
  highlight4_title: "Natural Retention",
  highlight4_desc: "Learn naturally and retain knowledge through enjoyable experiences",
  
  feature1_title: "Movement-Based Learning",
  feature1_desc: "Learn by moving, acting, and playing.",
  feature2_title: "Small Class, Big Support",
  feature2_desc: "Each child gets individual attention.",
  feature3_title: "All Levels Welcome - Japanese/English",
  feature3_desc: "No Japanese or English experience required.",
  feature4_title: "Multilingual & Inclusive",
  feature4_desc: "English support available; neurodiverse learners welcome.",
  feature5_title: "Confidence Building",
  feature5_desc: "Kids feel proud to use Japanese/English in daily life.",
  
  // Details
  details_title: "Location / Schedule",
  details_location: "Location:",
  details_location_value: "In-person in Toronto, or online classes available.",
  details_trial: "Free Trial:",
  details_trial_value: "Free trial classes available",
  details_start: "Program Start:",
  details_start_value: "Anytime (flexible start)",
  
  // Class Content
  content_title: "Class Content",
  content_subtitle: "Examples of class activities:",
  content_item1: "Japanese/English instruction games",
  content_item2: "Flashcards & movement games",
  content_item3: "Rhythm, songs, and action-based Japanese/English",
  content_item4: "Seasonal crafts",
  content_item5: "Real-life communication practice",
  content_goal: "Goal:",
  content_goal_text: "To help children learn Japanese/English not as \"study,\" but as a natural experience.",
  
  // Lesson Plans
  lesson_plans_title: "Sample Lesson Plans",
  lesson_25_title: "25-Minute Session (Short)",
  lesson_25_step1_title: "Warm-up (5 min)",
  lesson_25_step1_desc: "Movement games or mini exercises to get the body active",
  lesson_25_step2_title: "Introduction of new language (10 min)",
  lesson_25_step2_desc: "Hands-on experience with visuals and cards",
  lesson_25_step3_title: "Activity (7 min)",
  lesson_25_step3_desc: "Practice in pairs or small groups",
  lesson_25_step4_title: "Review & Wrap-up (3 min)",
  lesson_25_step4_desc: "Recap the words learned today",
  
  lesson_50_title: "50-Minute Session (Full)",
  lesson_50_step1_title: "Warm-up (5 min)",
  lesson_50_step1_desc: "Activate language through movement",
  lesson_50_step2_title: "Introduction of new words/grammar (15 min)",
  lesson_50_step2_desc: "Experiential, multi-sensory activities",
  lesson_50_step3_title: "Pair/Group activity (15 min)",
  lesson_50_step3_desc: "Roleplay or language games",
  lesson_50_step4_title: "Applied practice (10 min)",
  lesson_50_step4_desc: "Use language in real-life scenarios",
  lesson_50_step5_title: "Review & Wrap-up (5 min)",
  lesson_50_step5_desc: "Reflect on today's lesson and Q&A",
  
  // Homework
  homework_title: "Sample Homework",
  homework_item1: "Express today's words/phrases with drawings or gestures",
  homework_item2: "Practice reading simple dialogues aloud and record yourself",
  homework_item3: "Play mini-games at home with family or friends to practice",
  
  // Tuition
  tuition_title: "Tuition",
  tuition_contact_message: "For tuition information, please contact us.",
  
  // Instructor
  instructor_title: "Instructor",
  instructor_name: "Haru (Mari Haruno)",
  instructor_education_title: "Education & Credentials",
  instructor_education1: "Master's Degree in Agricultural Chemistry, Meiji University Graduate School",
  instructor_education2: "Behaviour Science Program Graduate, George Brown College",
  instructor_education3: "Special Needs Educator License",
  
  instructor_career_title: "Career",
  instructor_career1: "Since 2002, has been involved in education, with a special focus on children with developmental differences and school refusal.",
  instructor_career2: "Since 2016, relocated to Toronto, Canada, expanding instruction not only for Japanese learners but for people around the world.",
  instructor_career3: "In 2019, founded Haru's Bilingual School, the predecessor of J-Motion Academy.",
  instructor_career4: "In 2025, launched the Kids, Youth, Japanese (Adult), and English divisions within J-Motion Academy.",
  
  instructor_personal_title: "About Haru",
  instructor_favorite_food: "Favorite Foods: Pomegranate, Avocado Salad",
  instructor_favorite_color: "Favorite Color: Purple",
  instructor_favorite_phrase: "Favorite Phrase: GIVE IT A SHOT!!",
  instructor_personality: "Personality: Super positive, has the talent to continue what she starts for a long time, a master of perseverance. Easygoing.",
  
  instructor_episodes_title: "Haru's Stories",
  instructor_episode1: "As a graduate student, she suffered severe burns all over her body in an accident and narrowly escaped death. Unable to continue in science, she joined Rakuten and became a top performer among tens of thousands of salespeople.",
  instructor_episode2: "At a busy Tokyo intersection, she saved a boy who ran into the street from being hit by a truck. She was hit instead, requiring 25 stitches in her head, breaking her ribs, and losing all her teeth. She narrowly escaped death once again.",
  instructor_episode3: "A student who had been out of school for 8 years and was a shut-in began lessons with Haru. After six months, he said, 'I want to go to Toronto to see Haru-sensei!' and completed a two-week study abroad. After returning to Japan, he went back to high school and aimed for university—a tremendous transformation.",
  instructor_episode4: "A child with ADHD who couldn't concentrate in school and attended Japanese school for 4 years without speaking any Japanese at home joined Haru's group lesson. Immediately after the first day, he started humming songs in Japanese that he learned from Haru, and his motivation to learn Japanese soared.",
  
  instructor_dream_title: "Haru's Dream",
  instructor_dream: "To nurture 'global citizens' who can thrive anywhere in the world with confidence and resilience, developed through enhanced concentration and creativity. To spread worldwide a teaching style that incorporates neuroscience—using trampolines, color cones, and ladders instead of desks, chairs, textbooks, and pencils—engaging the whole body and all five senses, rather than the classic classroom setup.",
  
  // Parent Voices
  voices_title: "What People Say",
  voice1: "My child started using Japanese/English phrases at home right away!",
  voice2: "The movement-based learning style was perfect for my child!",
  voice3: "Haru-sensei's energy is so high that even on days when I come home feeling down, I always want to attend the class without fail. I'm so happy to learn real, practical English that can be used locally, not just from textbooks, and business trips abroad are no longer a burden.",
  voice4: "Before moving to Toronto, I wanted to do what I could on my own, but I didn't know where to start. After taking Haru-sensei's pre-study abroad English program, I clearly understood what I could do and what my weaknesses were. I continued until just before departure, and after arriving, I had no resistance to communicating in English.",
  voice5: "I hated studying and couldn't sit at a desk for more than 10 minutes, but I've been able to continue weekly 50-minute classes for 7 years. This is undoubtedly thanks to Haru-sensei's super positive energy and her teaching that truly never gets boring, tailored to each individual student. I can't thank Haru-sensei enough. I want to continue taking Haru-sensei's lessons for the rest of my life.",
  voice6: "Even after several years of learning Japanese with a textbook in hand, I was frustrated with my lack of progress and was about to give up when I met Haru-sensei. I was shocked by the sensation of absorbing native, living Japanese with my whole body, not from a textbook. I want everyone to experience this sensation of learning Japanese with their whole body.",
  
  // Registration
  registration_title: "Registration",
  registration_text: "Click below to register for the free trial class.",
  registration_cta: "Free Trial Registration",
  
  // Form Fields
  form_parent_name: "Parent/Guardian Name",
  form_child_name: "Child's Name",
  form_child_age: "Child's Age",
  form_select_age: "Select age",
  form_email: "Email Address",
  form_phone: "Phone Number (Optional)",
  form_trial_date: "Which date works best for the free trial?",
  form_select_date: "Select preferred date",
  form_weekdays_3pm: "Weekdays 3PM",
  form_saturday_2pm: "Saturday at 2PM",
  form_sunday_10am: "Sunday at 10AM",
  form_japanese_level: "Your child's Japanese/English level",
  form_select_level: "Select level",
  form_level_no_experience: "No experience / 初めて",
  form_level_beginner: "Beginner / 初級",
  form_level_can_speak_little: "Can speak a little / 少し話せる",
  form_level_can_understand: "Can understand simple Japanese/English / 少し理解できる",
  form_additional_info: "Anything we should know about your child? (Optional)",
  form_hear_about_us: "How did you hear about us? (Optional)",
  form_submitting: "Submitting...",
  form_success: "Thank you! Your registration has been received.",
  form_error: "Something went wrong. Please try again.",
  
  // FAQ
  faq_title: "FAQ",
  faq_q1: "My child doesn't speak any Japanese/English. Is it okay?",
  faq_a1: "Yes! We adjust using both English and Japanese.",
  faq_q2: "Can parents stay during class?",
  faq_a2: "Yes, absolutely. You can observe the free trial class, and we also prepare observation seats for subsequent classes, which you are welcome to use.",
  faq_q3: "Is the movement safe?",
  faq_a3: "Absolutely. All activities are simple and safe.",
  
  // Final CTA
  final_title: "You don't need to feel ready, you just need to take the first step. Give it a shot!! This is where your transformation begins.",
  final_cta: "Free Trial Registration",
  
  // Footer
  footer_copyright: "© 2025 J-Motion Academy. All rights reserved.",
  footer_link: "Website Builder",

  // About J-Motion Page
  about_hero_title: "Why J-Motion Academy?",
  about_hero_subtitle: "Learning that moves your whole body, mind, and heart",
  
  about_founder_title: "About the Founder, Haru (Mari Haruno)",
  about_founder_text1: "Haru (Mari Haruno) has supported and taught children and adults with developmental differences for over 20 years.",
  about_founder_text2: "Through this experience, she realized that classic learning—lining up desks and chairs, using textbooks and pencils—is not the only way to learn.",
  
  about_method_title: "The J-Motion Method",
  about_method_text1: "Based on neuroscience, J-Motion offers experiential lessons that engage all five senses. Learners acquire language not only with their mind but with their entire body.",
  about_method_text2: "Lessons are designed to be fun and natural, making language \"come alive\" in the body and creating memories that last a lifetime.",
  about_method_text3: "This method works for both Japanese and English and is especially beneficial for learners with strong developmental traits, providing a comfortable and enjoyable way to learn naturally.",
  
  about_highlights_title: "Lesson Highlights",
  about_highlight1: "Engage all five senses: speak, listen, see, touch",
  about_highlight2: "Active learning—not passive reception",
  about_highlight3: "Acquire language with your whole body, not just your mind",
  about_highlight4: "Fun and natural memory retention",
  
  about_lesson_plans_title: "Sample Lesson Plans",
  about_short_lesson: "25-Minute Session (Short)",
  about_short_warmup: "Warm-up (5 min): Movement games or mini exercises to get the body active",
  about_short_intro: "Introduction of new language (10 min): Hands-on experience with visuals and cards",
  about_short_activity: "Activity (7 min): Practice in pairs or small groups",
  about_short_review: "Review & Wrap-up (3 min): Recap the words learned today",
  
  about_full_lesson: "50-Minute Session (Full)",
  about_full_warmup: "Warm-up (5 min): Activate language through movement",
  about_full_intro: "Introduction of new words/grammar (15 min): Experiential, multi-sensory activities",
  about_full_activity: "Pair/Group activity (15 min): Roleplay or language games",
  about_full_practice: "Applied practice (10 min): Use language in real-life scenarios",
  about_full_review: "Review & Wrap-up (5 min): Reflect on today's lesson and Q&A",
  
  about_homework_title: "Sample Homework",
  about_homework1: "Express today's words/phrases with drawings or gestures",
  about_homework2: "Practice reading simple dialogues aloud and record yourself",
  about_homework3: "Play mini-games at home with family or friends to practice",
  
  about_cta_title: "Experience the J-Motion difference",
  about_cta_text: "Join us for a free trial class and discover how movement transforms language learning.",
  about_cta_button: "Book Your Free Trial"
};